import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
const links = [{
  label: 'El programa',
  href: '#programa'
}, {
  label: 'Bonos',
  href: '#bonos'
}, {
  label: 'Precio',
  href: '#precio'
}, {
  label: 'Preguntas',
  href: '#faq'
}];
export function Footer() {
  return <footer className="bg-navy py-14" data-id="element-105" data-mp="2a609q1i48raw">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-106" data-mp="2a69yjlrfcsf0">
        <div className="grid gap-10 lg:grid-cols-3 lg:items-start" data-id="element-107" data-mp="1mfmnwsq4joor">
          <div data-id="element-108" data-mp="1mdtfb7vyaue4">
            <span className="text-[13px] font-bold uppercase tracking-[0.2em] text-ice" data-id="element-109" data-mp="1hhbeuk7nli7l">
              Atleta<span className="text-gold" data-id="element-110" data-mp="1w5z6wgiaj9ss"> Corporativo™</span>
            </span>
            <p className="mt-4 max-w-xs text-[15px] leading-[1.7] text-cool" data-id="element-111" data-mp="1w823jjdy816h">
              El sistema de biohacking corporativo N°1 para profesionales
              argentinos de oficina.
            </p>
          </div>

          <nav aria-label="Secciones" className="lg:justify-self-center" data-id="element-112" data-mp="yqtoune7h0px">
            <ul className="flex flex-wrap gap-x-7 gap-y-3" data-id="element-113" data-mp="yoh8ufs0d0fi">
              {links.map(link => <li key={link.href} data-id="element-114" data-mp="1ehkfiiu4hpaz">
                  <a href={link.href} className="text-[13px] font-medium uppercase tracking-[0.1em] text-cool transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-115" data-mp="1ijnu3gc39a0h">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <ul className="space-y-2.5 text-[14px] text-cool lg:justify-self-end" data-id="element-116" data-mp="1sbl5oo70e3zq">
            <li data-id="element-117" data-mp="vksspzfdgs26">
              <a href="mailto:soporte@digilab.academy" className="inline-flex items-center gap-2.5 transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-118" data-mp="vlaxjkg3oelp">
                <MailIcon className="h-4 w-4 shrink-0 text-gold" strokeWidth={1.75} aria-hidden="true" data-id="element-119" data-mp="14iv1501fqmzh" />
                soporte@digilab.academy
              </a>
            </li>
            <li data-id="element-120" data-mp="2fzkzxy3j4cj2">
              <a href="https://instagram.com/atletacorporativo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-121" data-mp="2fy04m69e4pk5">
                <InstagramIcon className="h-4 w-4 shrink-0 text-gold" strokeWidth={1.75} aria-hidden="true" data-id="element-122" data-mp="1v8fnr3quvksp" />
                @atletacorporativo
              </a>
            </li>
            <li data-id="element-123" data-mp="258g88t0go6yh">
              <a href="https://atletacorporativo.digilab.academy" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 transition-colors duration-200 ease-smooth hover:text-gold" data-id="element-124" data-mp="256vcx16bojzk">
                <GlobeIcon className="h-4 w-4 shrink-0 text-gold" strokeWidth={1.75} aria-hidden="true" data-id="element-125" data-mp="1cjslet02d9it" />
                atletacorporativo.digilab.academy
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-12 border-t border-line pt-8" data-id="element-126" data-mp="1mb5cvjhy9xob">
          <p className="text-[13px] leading-[1.7] text-cool" data-id="element-127" data-mp="1hhu257a0owr4">
            © {new Date().getFullYear()} Atleta Corporativo™. Porque rendir al
            máximo en tu carrera no debería costarte la salud, la energía y los
            años con tu familia. Producto digital — no reemplaza consulta médica
            profesional.
          </p>
        </div>
      </div>
    </footer>;
}